async function fetchProductHandles(prodhandleslist) {
    // Generate a comma-separated list of product handles
    const handlesParam = prodhandleslist.join(',');
    const apiUrl = `https://on-request-example-dsy2vc5eca-uc.a.run.app/handles?handles=${handlesParam}`;
    
    try {
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log('Fetched data:', data); // Debugging the response

        if (!data.product_id || !Array.isArray(data.product_id)) {
            //throw new Error('Invalid product data');
            }
        return data.product_id.map(item => item[0]); // Extract product handles
    } catch (error) {
        console.error('Error fetching product handles:', error);
        return [];
    }
}

async function fetchProductData(handle) {
    try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) {
            throw new Error(`Failed to fetch product data for ${handle}`);
        }
        const product = await response.json();
        console.log(product)

        // Extract necessary data like vendor and inventory
        const vendor = product.vendor;
        const inventory = product.available; // Assuming the first variant for simplicity

        return {
            title: product.title,
            price: product.price,
            url: product.url,
            featured_image: product.featured_image,
            vendor,
            inventory
        };
    } catch (error) {
        console.error(`Error fetching product ${handle}:`, error);
        return null;
    }
}

function formatPrice(priceInCents) {
    return new Intl.NumberFormat('en-UK', {
        style: 'currency',
        currency: 'EUR' // Change this to your store's currency code
    }).format(priceInCents / 100);
}

// Function to generate inventory message
function getInventoryMessage(inventory) {
  console.log(inventory)
    return inventory == false ? 'Sold Out' : 'In Stock';
}



// Fallback product list for when no handles are provided

//https://on-request-example-dsy2vc5eca-uc.a.run.app/random?random=35
const fallbackProductList = [
                              "agrimin-bolus-24-7-magnesium",
                              "andis-ultra-edge-blades-no-50",
                              "andis-blades",
                              "advance-nutrition-platinum-beef-mineral-powder_25273",
                              "adjustable-show-stick",
                              "ambic-milk-sampler",
                              "all-trace-high-iodine-bolsus",
                              "acralube-5ltr",
                              "albex-gold-5ltrs",
                              "agvance-nutrition-platinum-pre-calver-mineral-powder-25kg",
                              "aesculap-gt506",
                              "aesculap-gt510",
                              "agritox-mcpa-nu46-10-litre-spray",
                              "aesculap-hoof-knife",
                              "agrimin-24-7-magnesium-bullets-cattle-10s",
                              "agrimin-24-7-smartrace-plus-sheep-bolus",
                              "all-sure-cattle-boluses-20-dose",
                              "https-www-youtube-com-watchvagrimin-24-7-smartrace-sheep-bolus",
                              "all-guard-5-in-1-applicator",
                              "all-guard-5-in-1-ewe-bolus",
                              "andis-ultra-edge-blades-no-15",
                              "agrihealth-lamb-reviver-kit-60ml",
                              "adult-show-coat",
                              "agrimin-cattle-bolus-applicator-b",
                              "30ml-automatic-drenching-gun",
                              "advance-nutrition-platinum-beef-powder-25kg-bag",
                              "albex-2-5-2-5litre",
                              "https-www-youtube-com-watchvall-trace-cattle-boluses",
                              "allsure-sheep-bolus-applicator",
                              "american-alloybrass-nose-lead",
                              "andisa-cordless-trimmer",
                              "ambic-coil",
                              "andis-ultra-edge-blades-no-40",
                              "agvance-footrot-shears",
                              "agri-gel"
                          ]
        
// Function to get 10 random products from the fallback list
function getRandomFallbackHandles() {
    const shuffled = fallbackProductList.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 10); // Return a random selection of 10 items
}



async function displayRecommendations(prodhandleslist) {
    const section = document.querySelector('.aiton-recom-section');
    console.log()
    const container = document.querySelector('.product-section--content');
    const sectionTitle = document.querySelector('.product-section--title.product-recommendations--title');


    if (!section || !container) {
        console.error("Section or container not found");
        return;
    }

    // Retrieve lastViewedProducts and home_handles from sessionStorage
    const lastViewedProducts = JSON.parse(sessionStorage.getItem('lastViewedProducts')) || [];
    let homeHandles = JSON.parse(sessionStorage.getItem('home_handles')) || [];

    // Check if lastViewedProducts matches the current prodhandleslist
    const handlesMatch = (
        lastViewedProducts.length === prodhandleslist.length &&
        lastViewedProducts.every((handle, index) => handle === prodhandleslist[index])
    );

    let handles;

    // If lastViewedProducts matches prodhandleslist, use homeHandles
    if (handlesMatch && homeHandles.length > 0) {
        console.log('Using stored homeHandles from sessionStorage since lastViewedProducts matches prodhandleslist.');
        handles = homeHandles;
    }else if (prodhandleslist.length === 0) {
        // If no products have been clicked, use the fallback product list
        console.log('Using fallback product handles.');

        // Change the title text when no product is clicked
        if (sectionTitle) {
            sectionTitle.innerText = "Trending Products";
        }
        
        handles = getRandomFallbackHandles();
    }else {
        // Fetch new product handles if lastViewedProducts and prodhandleslist are different
        console.log('Fetching new product handles because lastViewedProducts does not match prodhandleslist.');

        // Fetch new product handles
        handles = await fetchProductHandles(prodhandleslist);

        if (!Array.isArray(handles) || handles.length === 0) {
            console.error('No valid product handles found');
            section.style.display = 'none';
            return;
        }

        // Save the fetched handles and update sessionStorage
        sessionStorage.setItem('home_handles', JSON.stringify(handles));
        sessionStorage.setItem('lastViewedProducts', JSON.stringify(prodhandleslist));
    }

    section.style.display = 'block';
    container.innerHTML = ''; // Clear the container

    // Fetch and display product data for each handle
    for (const handle of handles) {
        const product = await fetchProductData(handle);
        if (product) {
            const productElement = document.createElement('li');
            productElement.className = 'grid__item';

            // Construct the product HTML with vendor and inventory details
            productElement.innerHTML = `
                <a href="${product.url}" class="product-link">
                    <img src="${product.featured_image}" alt="${product.title}" class="portrait">
                    <div class="product-details">
                      <p>${product.title}</p>
                      <span class="vendor">${product.vendor}</span>
                      <span class="price">${formatPrice(product.price)} EUR</span>
                      <span class="inventory">${getInventoryMessage(product.inventory)}</span>
                    </div>
                </a>
            `;
            container.appendChild(productElement);
        } else {
            console.warn(`Product ${handle} could not be displayed.`);
        }
    }
}

// Event listener for DOMContentLoaded to initialize recommendations
(async function initializeRecommendations() {
    const productHandle = document.querySelector('body').getAttribute('data-product-handle');
    let prodhandleslist = JSON.parse(sessionStorage.getItem('prodhandleslist') || '[]');

    if (productHandle && !prodhandleslist.includes(productHandle)) {
        prodhandleslist.push(productHandle);
    }

    sessionStorage.setItem('prodhandleslist', JSON.stringify(prodhandleslist));

    if (prodhandleslist.length > 0) {
        displayRecommendations(prodhandleslist).catch(error => console.error('Error displaying recommendations:', error));
    } else {
        displayRecommendations(prodhandleslist).catch(error => console.error('Error displaying recommendations:', error));
        console.error('No product handles found.');
    }
})();



